import 'whatwg-fetch';
import 'babel-polyfill';
import sprintf from 'sprintf';

class SMGraphQLClient {
  defaultOptions(){
    return {
      method: "POST",
      headers: {
        Authorization: sprintf("Bearer %s", SpaceMarket.Session.AccessToken),
        'x-api-key': SpaceMarket.Config.APIKey,
        'Spacemarket-Version': SpaceMarket.Config.APIVersion,
        'Content-Type': "application/json",
        'Accept': "application/json",
        'Accept-Language': 'ja-jp',
      },
      mode: 'cors',
      credentials: 'include',
    };
  }

  checkStatus(response) {
    if (response.status >= 200 && response.status < 300) {
      return response;
    } else {
      let error = new Error(response.statusText);
      error.response = response;
      throw error;
    }
  }

  parseJSON(response) {
    return response.json();
  }

  async request(q, v = {}){
    const url = SpaceMarket.Config.APIV2Url;

    let options = this.defaultOptions();
    options['body'] = JSON.stringify({ query: q, variables: v});

    const result = await fetch(url, options).
      then(this.checkStatus).
      then(this.parseJSON).
      then((json) => {return json;}).
      catch((ex) => {console.log(ex);});

    return result;
  }
}
export default SMGraphQLClient;



// WEBPACK FOOTER //
// ./app/javascript/lib/SMGraphQLClient.js